<template>
    <div class="error-container">
        <i class="el-icon-back p-4 back-btn" @click="goToHome"></i>
        <div class="text-center error-txt">
            <h1>404</h1>
            <p>We're sorry but it looks like that page doesn't exist anymore. Back to <router-link tag="a" to="/" exact class="link-text">home</router-link></p>
            <input v-model="search" placeholder="Try searching for what you were looking for..." />
            <button
                @click="goToHome"
            >
                <i class="el-icon-search"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
	name: "NotFound",
    data() {
        return {
            search: ''
        };
    },
    methods: {
        goToHome() {
            this.$router.push({
                path: "/"
            }).catch(()=>{});
        }
    }
};
</script>

<style scoped>
.error-container {
	padding: 0;
	margin: 0;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	background-color: rgba(255, 130, 45, 0.85);
	color: #fff;
}

.error {
	text-align: center;
	padding: 16px;
	position: relative;
	top: 50%;
	transform: translateY(-50%);
	-webkit-transform: translateY(-50%);
}

h1 {
	margin: -10px 0 -30px;
	font-size: calc(17vw + 40px);
	opacity: 0.8;
	letter-spacing: -17px;
}

p {
	opacity: 0.8;
	font-size: 20px;
	margin: 8px 0 38px 0;
	font-weight: bold;
}

input,
button,
input:focus,
button:focus {
	border: 0;
	outline: 0 !important;
}

input {
	width: 350px;
	padding: 14px;
	max-width: calc(100% - 80px);
	border-radius: 6px 0 0 6px;
	font-weight: 400;
	font-family: "Montserrat", sans-serif;
}

button {
	width: 40px;
	padding: 14.5px 16px 14.5px 12.5px;
	vertical-align: top;
	border-radius: 0 6px 6px 0;
	color: #fff;
	background: #d26300;
	cursor: pointer;
	transition: all 0.4s;
}

button:hover {
	color: white;
	background: #9a5c32;
}

.back-btn {
	position: fixed;
	/* top: 30px; */
	/* left: 30px; */
	font-size: 2em;
	color: white;
	text-decoration: none;
    font-weight: bold;
    cursor: pointer;
}

.error-txt {
    margin-top: 10rem;
}

.link-text {
	color: #FFF;
}
</style>
